<template>
  <b-modal id="bv-modal-region"
           :ok-only="true"
           @hide="onHide"
           @ok="onOk"
           ref="modal"
           ok-variant="plm-primary"
           data-test-path="dialog-region"
  >
    <template v-slot:modal-title>
      Select Region
    </template>
    <select class="form-control" ref="selection" v-model="selectedRegion">
      <option v-for="region in regions" :value="region.code">
        {{ region.label }}
      </option>
    </select>

  </b-modal>

</template>

<script>

import _ from "lodash";

export default {
  name: "RegionDialog",
  async beforeMount() {
  },
  methods: {

    async onHide(ev) {
      if (this.resolve != null) {
        this.resolve(false);
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },

    async onOk(ev) {
      if (this.resolve != null) {
        this.resolve(this.$refs.selection.value);
        this.resolve = null;
      }
    },

    reset(currentRegion) {
      this.resolve = null;
      this.selectedRegion = currentRegion;
      this.regions = this.getRegions();
    },

    getRegions() {
      let regionsConf = SessionManager.regionsConfig;
      let res = [];
      res.push({
        lang: null,
        region: null,
        type: 'default',
        code: 'def',
        label: 'Default',
        flag: '',
        language: '',
        order: 0
      });

      let map = {};
      regionsConf.regions.forEach(region => {
        if (!map?.[region.baseLanguage]) {
          map[region.baseLanguage] = [];
        }
        map[region.baseLanguage].push(region);
      });

      let langsByCode = {};
      for (let lang of regionsConf.enabledLanguages) {
        if (map[lang.code].length === 1) {
          continue;
        }
        langsByCode[lang.code] = lang;
        res.push({
          lang: lang,
          region: null,
          type: 'lang',
          code: lang.code,
          label: lang.enName + " - base translation",
          flag: lang.code,
          language: lang.code,
          order: 1,
        })
      }

      for (let reg of regionsConf.regions) {
        let lang = langsByCode[reg.baseLanguage];
        res.push({
          lang: lang,
          region: reg,
          type: 'region',
          code: "r_" + reg.fixedSymbol,
          label: (lang?.enName ?? 'Default') + " - Region: " + reg.name + "",
          flag: (reg.countryCode || reg.baseLanguage).toLowerCase(),
          language: reg.baseLanguage,
          order: 2,
        })
      }
      res.sort((a, b) => {
        if (a.type === 'default') {
          return -1;
        }
        if (b.type === 'default') {
          return 1;
        }
        if (a.lang?.enName === b.lang?.enName) {
          if (!a.region) {
            return -1;
          }
          if (!b.region) {
            return 1;
          }
          if (a.region.name < b.region.name) {
            return -1;
          }
          if (a.region.name > b.region.name) {
            return 1;
          }
          return 0;
        }
        if (!a.lang) {
          return -1;
        }
        if (!b.lang) {
          return 1;
        }

        if (a.lang.enName < b.lang.enName) {
          return -1;
        }
        if (a.lang.enName > b.lang.enName) {
          return 1;
        }
        return 0;
      });
      return res;
    }
  },
  data: function () {
    return {
      selectedRegion: 'def',
      regions: this.getRegions(),
      resolve: null,
    }
  }
}
</script>
